export function separateWords(input: string): string {
    // Use a regular expression to identify capital letters
    const wordsArray = input.split(/(?=[A-Z])/);

    // Join the words with a space
    const separatedWords = wordsArray.join(" ");

    return separatedWords;
}
